import { useEffect, useState } from "react";
import axios from "axios";
import {
  API,
  fallbackBrand,
  fallbackContact,
  fallbackMenu,
  fallbackMenuNote,
  fallbackPartners,
  fallbackPromotions,
  fallbackReviews,
} from "@/constants/nossaData";

export function useNossaData() {
  const [brand, setBrand] = useState(fallbackBrand);
  const [menu, setMenu] = useState(fallbackMenu);
  const [menuNote, setMenuNote] = useState(fallbackMenuNote);
  const [contact, setContact] = useState(fallbackContact);
  const [reviews, setReviews] = useState(fallbackReviews);
  const [partners, setPartners] = useState(fallbackPartners);
  const [promotions, setPromotions] = useState(fallbackPromotions);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [brandResponse, menuResponse, contactResponse, reviewsResponse, partnersResponse, promotionsResponse] = await Promise.all([
          axios.get(`${API}/brand`),
          axios.get(`${API}/menu/full`),
          axios.get(`${API}/contact`),
          axios.get(`${API}/reviews`),
          axios.get(`${API}/partners`),
          axios.get(`${API}/promotions`),
        ]);
        setBrand(brandResponse.data);
        setMenu(menuResponse.data.items || menuResponse.data);
        setMenuNote(menuResponse.data.note || fallbackMenuNote);
        setContact(contactResponse.data);
        setReviews(reviewsResponse.data);
        setPartners(partnersResponse.data);
        setPromotions(promotionsResponse.data);
      } catch {
        return;
      }
    };

    loadData();
  }, []);

  return { brand, menu, menuNote, contact, reviews, partners, promotions };
}